import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold text-orange-500 hover:text-orange-400 transition-colors">
            CONPR<span className="logo-o-bounce">O</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#about" className="text-gray-300 hover:text-orange-500 transition-colors whitespace-nowrap">About</a>
            <a href="#services" className="text-gray-300 hover:text-orange-500 transition-colors whitespace-nowrap">Services</a>
            <a href="#contact" className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg transition-colors whitespace-nowrap cursor-pointer">Contact Us</a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 animate-fade-in">
            <a 
              href="#about" 
              className="block text-gray-300 hover:text-orange-500 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </a>
            <a 
              href="#services" 
              className="block text-gray-300 hover:text-orange-500 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </a>
            <a 
              href="#contact" 
              className="block bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg transition-colors text-center cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
